module.exports = __webpack_public_path__ + "img/logo_dpd.2b0d5f78.png";